"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Helper = void 0;
const BiMath_1 = require("./BiMath");
class Web3Helper {
    static ShortLabel(wr, value = undefined, round = 3, symbol = "") {
        if (!value) {
            wr.text = "-";
            wr.onclick = undefined;
            return;
        }
        let post = "";
        if (symbol)
            post = " " + symbol;
        wr.text = BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(value), round) + post;
        wr.onclick = () => wr.text = BiMath_1.BiMath.ToEth(value) + post;
    }
    static ToLargeNumberUnit(value, round = 3, symbol = "") {
        if (!value)
            return "-";
        let post = "";
        if (symbol)
            post = " " + symbol;
        const eth = BiMath_1.BiMath.ToEth(value);
        let dec = parseFloat(eth);
        if (dec < 1)
            return BiMath_1.BiMath.TruncEth(BiMath_1.BiMath.ToEth(value), round) + post;
        let acc = dec;
        let exp = 0;
        while (acc >= 1000) {
            acc = acc / 1000;
            exp++;
        }
        return Math.trunc(acc * 10) / 10 + Web3Helper.GetLargeNumberUnit(exp) + post;
    }
    static GetLargeNumberUnit(exp = 0) {
        switch (exp) {
            case 0: return "";
            case 1: return "k";
            case 2: return "M";
            case 3: return "B";
            case 4: return "T";
            case 5: return "Qa";
            case 6: return "Qi";
            case 7: return "Sx";
            case 8: return "Sp";
            case 9: return "Oc";
            case 10: return "No";
            default: return "-";
        }
    }
}
exports.Web3Helper = Web3Helper;
//# sourceMappingURL=Web3Helper.js.map